import { TestType } from "@app/provider/testData/types";
import { NEVA_HEAP_EVENTS, nevaEventContent } from "@app/neva/models/constants";
import { testTypeToBotId } from "@app/neva/helpers/testTypeToBotId";

export type NevaHeapVideoEvents = {
  videoContent: string;
  timeoutEvent: NEVA_HEAP_EVENTS;
};

export const getNevaHeapVideoEvents = (
  botId: string
): NevaHeapVideoEvents | undefined => {
  switch (botId) {
    case testTypeToBotId(TestType.HORIZON):
      return {
        videoContent: nevaEventContent.NEVAHorizonDiseaseSpecific,
        timeoutEvent: NEVA_HEAP_EVENTS.POS_GEN_VIDEO_TIMEOUT,
      };
    case testTypeToBotId(TestType.PANORAMA):
      return {
        videoContent: nevaEventContent.NEVAPanoramaDiseaseSpecific,
        timeoutEvent: NEVA_HEAP_EVENTS.HIGH_RISK_VIDEO_TIMEOUT,
      };
    default:
      return undefined;
  }
};
